module.exports = __webpack_public_path__ + "static/media/Soybean3V1-V3.48d6cbe6.PNG";